import FilterIcon from '@/common/assets/icons/filterIcon.svg?react';
import MainModal from '@/common/components/base/modal/Modal';
import useModal from '@/common/hooks/useModal';
import AdvanceFilterForm from '@/modules/FileList/components/listFilterSection/advanceFilter/AdvanceFilterForm';

export default ({ hasDateOrFileState }: { hasDateOrFileState?: boolean }) => {
  const { openModal, open, closeModal } = useModal({});
  return (
    <>
      <FilterIcon onClick={openModal} />
      <MainModal open={open} closeModal={closeModal}>
        <AdvanceFilterModals
          hasDateOrFileState={hasDateOrFileState}
          closeModal={closeModal}
        />
      </MainModal>
    </>
  );
};

const AdvanceFilterModals = ({
  closeModal,
  hasDateOrFileState,
}: {
  closeModal: () => void;
  hasDateOrFileState?: boolean;
}) => {
  return (
    <AdvanceFilterForm
      hasDateOrFileState={hasDateOrFileState}
      onCloseModal={closeModal}
    />
  );
};
